import { useTranslation } from 'next-i18next';
import { ISupplier } from '@bridebook/models/source/models/Suppliers.types';
import { Box, ImageX } from '@bridebook/ui';
import IconPhotographer from '@bridebook/ui/src/components/svg/icon-photographer';
import { ABOUT_ME_SECTION_ID } from '@bridebook/web/app-shared/components/supplier/sections/ids';
import { IMAGES_BASE_URL } from '@bridebook/toolbox/src/buildImageUrl';
import componentStyles from '@bridebook/web/app-basic/components/supplier/sections/about-me/about-me.style';

export interface IProps {
  supplier?: ISupplier | null;
}

const AboutMe = ({ supplier }: IProps) => {
  const { t } = useTranslation('supplier');

  const descriptionShort = supplier?.description?.short;
  const { intro, name, personalityTags, avatarPath } = { ...supplier?.about };

  if (!descriptionShort) return null;

  const styles = componentStyles();

  return (
    <Box style={styles.wrapper} id={ABOUT_ME_SECTION_ID}>
      <Box alignItems="center">
        <Box style={styles.avatarWrapper}>
          {avatarPath ? (
            <ImageX w={320} h={320} src={`${IMAGES_BASE_URL}/${avatarPath}`} style={styles.image} />
          ) : (
            <Box style={styles.previewAvatar}>
              <IconPhotographer />
            </Box>
          )}
        </Box>
        <Box style={styles.title}>{t('introduction', { name })} 👋</Box>
        <Box flexDirection="row" style={styles.tagWrapper}>
          {personalityTags?.map((tag, index) => (
            <Box key={index} style={styles.tag}>
              {tag}
            </Box>
          ))}
        </Box>
        {intro && <Box style={styles.quote}>{intro}</Box>}

        <Box style={styles.description}>{descriptionShort}</Box>
      </Box>
    </Box>
  );
};

export default AboutMe;
